export default __webpack_public_path__ + "static/media/logo_transparent.72122965.png";